import {resources} from "../../../../../../../core/models/resource/resources";

export const testingResultFilesResourceType = resources['testing-result-files'];
export const testingResultsResourceType = resources['testing-results'];
export const testingResultsFileType = 'TESTING_RESULTS';
